import axiosInstance from '../actions/AxiosInstance';
import api from '../actions/EndPoints';

/**
 * Hook that provides cache service functionality
 * Makes API call to cache endpoint with provided API key
 *
 * @returns {Object} Object containing cache service functions
 * @returns {Function} callCacheService - Function that calls cache API with key parameter
 */
export const useCacheServices = () => {
    /**
     * Calls the cache API endpoint with the provided API key
     * This call will cache user data from IDM database, thereby reducing time for MGP to fetch user data
     * @param {string} key - API key for authentication
     */
    const callCacheService = async (key) => {
        await axiosInstance.get(api.cacheAPI, {
            headers: { apiKey: `${key}` },
        });
    };

    return { callCacheService };
};
